import 'babel-polyfill'
require('es6-promise').polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/css/main.css'

// google map
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyA8ZcpJdXSzxrEO6YyiD6kE3Kab9dLLFHc', libraries: 'places,drawing,visualization' }, installComponents: true })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js